export type SearchParamsType = {
  filter: {
    status: number;
    searchText: string;
  };
  sortOrder: string;
  sortField: string;
  pageNumber: number;
  pageSize: number;
};

export type MasterTableDataType = {
  clinicId: number;
  nationality: string;
  createdById: number;
  createdDate: string;
  countryCode: string;
  countryName: string;
  countryId: number;
  countryStatus: number;
  isoCode: string;
};

export type MasterDataType = {
  countryId: number;
  clinicId: number;
  isoCode: string;
  createdById: number;
  countryName: string;
  countryStatus: number;
  countryCode: string;
  nationality: string;
};

export type SaveResponseType = {};

export type MasterFormDataType = {
  isoCode: string;
  countryCode: string;
  countryName: string;
  nationality:string;
  countryStatus: number;
};

export const initialFormData: MasterFormDataType = {
  isoCode: "",
  countryCode: "",
  countryName: "",
  nationality:"",
  countryStatus: 1,
};
